import {Heading, Pane} from "evergreen-ui";
import React from "react";
import {ClientManagementLayout} from "../../layouts/ClientManagementLayout";
import {PORTAL_NAVY} from "../../../common";
import {ProgressPortraitDownloadAuditTable} from "./ProgressPortraitDownloadAuditTable";


export const ProgressPortraitDownloadAuditPage = () => (
    <ClientManagementLayout customSelection={'Progress Portrait'}>
        <Pane className="m-5 p-5 bg-white shadow-md rounded flex flex-col" flexGrow={1}
              minHeight="calc(100vh - 100px - 260px - 36px)">
            <Heading size={700} color={PORTAL_NAVY} marginBottom={24}>Progress Portrait Download Log</Heading>
            <ProgressPortraitDownloadAuditTable/>
        </Pane>
    </ClientManagementLayout>
);
